define(
({
  "select_shipping_method": "発送方法を選択"
})
);
